import { combineReducers } from 'redux';
import diffusion from './diffusion';
import { INITIAL_DATA_LOAD_SUCCESS } from '../actions';

const isFetched = (state = false, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isFetched,
  diffusion,
});

export const getIsFetched = state => state.isFetched;



// WEBPACK FOOTER //
// ./src/modules/campaign/reducers/index.js